/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminInvitationGetInvitationsParams,
  CreateOrganizationInvitationDTO,
  OrganizationInvitationDTO,
  OrganizationInvitationDTOQueryResultDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminInvitationGetInvitations = (
    organizationId: number,
    params?: AdminInvitationGetInvitationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationInvitationDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminInvitation`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminInvitationGetInvitationsQueryKey = (organizationId: number,
    params?: AdminInvitationGetInvitationsParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminInvitation`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminInvitationGetInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminInvitationGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvitationGetInvitationsQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvitationGetInvitations>>> = ({ signal }) => adminInvitationGetInvitations(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvitationGetInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvitationGetInvitations>>>
export type AdminInvitationGetInvitationsQueryError = ErrorType<unknown>


export function useAdminInvitationGetInvitations<TData = Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminInvitationGetInvitationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvitationGetInvitations>>,
          TError,
          Awaited<ReturnType<typeof adminInvitationGetInvitations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvitationGetInvitations<TData = Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminInvitationGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvitationGetInvitations>>,
          TError,
          Awaited<ReturnType<typeof adminInvitationGetInvitations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvitationGetInvitations<TData = Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminInvitationGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminInvitationGetInvitations<TData = Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminInvitationGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvitationGetInvitations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvitationGetInvitationsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminInvitationCreateInvitation = (
    organizationId: number,
    createOrganizationInvitationDTO: CreateOrganizationInvitationDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationInvitationDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminInvitation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationInvitationDTO, signal
    },
      );
    }
  


export const getAdminInvitationCreateInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvitationCreateInvitation>>, TError,{organizationId: number;data: CreateOrganizationInvitationDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminInvitationCreateInvitation>>, TError,{organizationId: number;data: CreateOrganizationInvitationDTO}, TContext> => {
    
const mutationKey = ['adminInvitationCreateInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvitationCreateInvitation>>, {organizationId: number;data: CreateOrganizationInvitationDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminInvitationCreateInvitation(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminInvitationCreateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvitationCreateInvitation>>>
    export type AdminInvitationCreateInvitationMutationBody = CreateOrganizationInvitationDTO
    export type AdminInvitationCreateInvitationMutationError = ErrorType<unknown>

    export const useAdminInvitationCreateInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvitationCreateInvitation>>, TError,{organizationId: number;data: CreateOrganizationInvitationDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvitationCreateInvitation>>,
        TError,
        {organizationId: number;data: CreateOrganizationInvitationDTO},
        TContext
      > => {

      const mutationOptions = getAdminInvitationCreateInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminInvitationResendInvitation = (
    organizationId: number,
    invitationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationInvitationDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminInvitation/${invitationId}/resend`, method: 'POST', signal
    },
      );
    }
  


export const getAdminInvitationResendInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvitationResendInvitation>>, TError,{organizationId: number;invitationId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminInvitationResendInvitation>>, TError,{organizationId: number;invitationId: number}, TContext> => {
    
const mutationKey = ['adminInvitationResendInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvitationResendInvitation>>, {organizationId: number;invitationId: number}> = (props) => {
          const {organizationId,invitationId} = props ?? {};

          return  adminInvitationResendInvitation(organizationId,invitationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminInvitationResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvitationResendInvitation>>>
    
    export type AdminInvitationResendInvitationMutationError = ErrorType<unknown>

    export const useAdminInvitationResendInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvitationResendInvitation>>, TError,{organizationId: number;invitationId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvitationResendInvitation>>,
        TError,
        {organizationId: number;invitationId: number},
        TContext
      > => {

      const mutationOptions = getAdminInvitationResendInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminInvitationRevokeInvitation = (
    organizationId: number,
    invitationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationInvitationDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminInvitation/${invitationId}/revoke`, method: 'POST', signal
    },
      );
    }
  


export const getAdminInvitationRevokeInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvitationRevokeInvitation>>, TError,{organizationId: number;invitationId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminInvitationRevokeInvitation>>, TError,{organizationId: number;invitationId: number}, TContext> => {
    
const mutationKey = ['adminInvitationRevokeInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvitationRevokeInvitation>>, {organizationId: number;invitationId: number}> = (props) => {
          const {organizationId,invitationId} = props ?? {};

          return  adminInvitationRevokeInvitation(organizationId,invitationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminInvitationRevokeInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvitationRevokeInvitation>>>
    
    export type AdminInvitationRevokeInvitationMutationError = ErrorType<unknown>

    export const useAdminInvitationRevokeInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvitationRevokeInvitation>>, TError,{organizationId: number;invitationId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminInvitationRevokeInvitation>>,
        TError,
        {organizationId: number;invitationId: number},
        TContext
      > => {

      const mutationOptions = getAdminInvitationRevokeInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    